export default __webpack_public_path__ + "static/media/557.c632db83.gif";